module.exports = __webpack_public_path__ + "img/error_validate.e8ada04e.svg";